import React from 'react';
import { SignupAccountView, SignupLayout } from '../components';
import { useSignupAccountViewController } from '../controllers';

const SignupAccountPage: React.FC = () => {
  const { formValues, errors, formError, submitting, handleChange, submit } =
    useSignupAccountViewController();

  return (
    <SignupLayout>
      <SignupAccountView
        formValues={formValues}
        errors={errors}
        formError={formError}
        submitting={submitting}
        onChange={handleChange}
        onSubmit={submit}
      />
    </SignupLayout>
  );
};

export default SignupAccountPage;
